<template>
    <v-tab-item eager>
        <v-card
            color="grey lighten-3"
            flat
        >
            <v-card-text>

                <div class="grid mt-2" >
                    <v-radio-group v-model="internalValue">
                        <v-radio
                            v-for="item in items"
                            :key="item.id"
                            :id="`${resourceName}_${item.id}`"
                            :value="item.id"
                            class="mr-3"
                            :label="item.name"
                        />
                    </v-radio-group>
                </div>

            </v-card-text>
        </v-card>
    </v-tab-item>
</template>
<script>

export default {
        name: 'BooleanFilterItem',
        props: {
            value: {
                type: [Boolean],
                default: null
            },
            resourceName: String
        },

        data() {
            return {
                items: [
                    {id: null,  name: 'unset'},
                    {id: true,  name: 'active'},
                    {id: false, name: 'inactive'},
                ],
                internalValue: this.value,
                pending:       false,
                showLoading:   false,
            };
        },

        watch: {
            // update internal value based on external changes
            value(newValue) {
                this.internalValue = newValue
            },

            // emit event when internal filters are changed
            internalValue(newInternalValue) {
                this.$emit('input', newInternalValue)
            },
        },

        methods: {
            deselect() {
                this.internalValue = null;
            },

            deselectAll() {
                this.internalValue = null;
            },

            selectAllFiltered() {
                this.internalValue = true;
            },

            toggleSelect() {
                if (this.internalValue === null) {
                    this.internalValue = true;
                } else {
                    this.internalValue = true;
                }
            },

            selectFilteredValue() {

            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../../node_modules/vuetify/src/components/VCard/variables";
    @import "../../../../node_modules/vuetify/src/components/VChip/variables";

    .row {
        flex-wrap: nowrap;
        overflow: auto;
    }

    .grid {
        display: grid;
        grid-template-rows: repeat(6, calc(#{$card-text-font-size} + 1.5rem));
        grid-auto-flow: column;
        justify-content: start;
        overflow-x: auto;
    }

    .grid label {
        white-space: nowrap;
        margin-right: 1rem;
        margin-bottom: 0.5rem;
    }

    .grid label input:focus + span {
        color: var(--main-header);
        text-shadow: 0px 0px 6px var(--table-no-data-color);
    }

    .v-item-group {
        min-height: 3rem;
    }

    div.magnify i {
        background-color: var(--main-header);
        border-radius: 100px;
        padding: 16px;
    }
    div.magnify {
        margin-top: 6px;
    }
    div.filter-description p {
        margin-bottom: 0;
    }
    div.v-card__subtitle {
        display: flex;
        gap: 16px;
        padding-bottom: 0;
    }
    div.v-input.filter-checkboxes {
        margin-top: 0 !important;
    }

    [type="checkbox"] + span {
        padding-right: 8px;
    }
    [type="checkbox"] {
        position: relative;
        left: 15px;
        top: -4px;
        z-index: 0;
        -webkit-appearance: none;
    }
    [type="checkbox"] + span::before {
        width: 24px;
        height: 24px;
        background-image: url("../../../assets/icons/check_box_unchecked.svg");
        background-size: 24px;
        display: block;
        content: "";
        float: left;
        z-index: 5;
        position: relative;
        margin-right: -6px;
    }
    [type="checkbox"]:checked+span::before {
        background-image: url("../../../assets/icons/check_box_checked.svg");
    }
</style>
